<template>
  <div class="columns">
    <div class="column is-11s is-offset-1">
      <div>
        <div class="file">
          <div class="media is-flex">
            <div class="media-left">
              <span class="icon is-large" :style="style"><i class="fa-5x" :class="fileType.class"></i></span>
            </div>
            <div class="media-content">
              <p class="title is-4 is-marginless">{{name}}</p>
              <p class="subtitle is-6 is-marginless">{{size}}</p>
              <button v-if="!context" @click="go" class="download button is-rounded is-small">Download</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileType from '@/libs/file-type'

export default {
  props: ['attachment', 'context'],
  computed: {
    metadata: function () {
      return this.attachment.metadata || {}
    },
    name: function () {
      return this.metadata.name || ''
    },
    contentType: function () {
      return this.metadata.type || ''
    },
    size: function () {
      let size = this.metadata.size || 0

      if (isNaN(size)) {
        return `${size} ${this.descr}`
      }

      let unit = ''
      if (size < 1000) {
        unit = 'B'
      } else if (size < 1000000) {
        size = Math.round(size / 1000, 2)
        unit = 'KB'
      } else if (size < 1000000000) {
        size = Math.round(size / 1000000, 2)
        unit = 'MB'
      }

      if (size === 0) {
        return this.descr
      }

      return `${size} ${unit} ${this.descr}`
    },
    fileType: function () {
      return fileType.iconForNameOrType(this.name, this.contentType)
    },
    style: function () {
      const style = {}

      if (this.fileType.colour) {
        style.color = this.fileType.colour
      }

      return style
    },
    descr: function () {
      return this.fileType.descr
    },
    isLegacy: function () {
      return this.metadata.isDownloadable === undefined
    }
  },
  methods: {
    go: function () {
      window.open(this.attachment.url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .columns {
    max-width: 100%;
    padding: 0.5rem;
    height: 100%;
    align-items: center;
  }

  .icon {
    display: block;
  }

  .media-content {
    margin-left: 1rem;
    p {
      padding-bottom: 0.6rem;
    }
  }

  .file{
    cursor: pointer;
    margin: 4rem 3rem;
  }

  .title {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
</style>
